module.exports = __webpack_public_path__ + "static/media/icon-money-owed.d022f02b.svg";